<script setup lang="ts">
import { computed } from 'vue'
import { CButton } from '@/shared/ui'

// Campaign statuses:
// 4 - ready (can start)
// 9 - active (can pause)
// 11 - paused (can start)
// 7 - finished

const props = defineProps<{
  status: number
  onStart?: () => void
  onPause?: () => void
  onAction?: () => void
  isLoading?: boolean | false
}>()

// Can start when status is 4 (ready) or 11 (paused)
const canStart = computed(() => props.status === 4 || props.status === 11)

// Can pause when status is 9 (active)
const canPause = computed(() => props.status === 9)

function handleAction(action: 'start' | 'pause') {
  if (action === 'start' && props.onStart) {
    props.onStart()
  }
  else if (action === 'pause' && props.onPause) {
    props.onPause()
  }
  else if (props.onAction) {
    // Fallback to onAction for backward compatibility
    props.onAction()
  }
}
</script>

<template>
  <div class="flex gap-2">
    <!-- Start Button - shown for status 4 (ready) and 11 (paused) -->
    <CButton
      v-if="canStart"
      type="primary"
      size="small"
      class="!px-2 !py-1.5 text-sm !h-8 !font-semibold"
      :disabled="isLoading"
      @click="handleAction('start')"
    >
      <CIcon icon="hugeicons:play" class="text-xl" />
      {{ $t("action_start") }}
    </CButton>

    <!-- Pause Button - shown for status 9 (active) -->
    <CButton
      v-if="canPause"
      type="primary"
      size="small"
      class="!px-2 !py-1.5 text-sm !h-8 !font-semibold"
      :disabled="isLoading"
      @click="handleAction('pause')"
    >
      <CIcon icon="hugeicons:pause" class="text-xl" />
      {{ $t("action_pause") }}
    </CButton>
  </div>
</template>
